import React from 'react'
import styled from 'styled-components'

import { Review } from '../../../data/book/data-types'
import ReviewItem from './review'

type ReviewListProps = {
  reviews?: Review[]
  final: boolean
  emptyState: string
  focus: 'author' | 'book'
}

const ReviewList: React.FunctionComponent<ReviewListProps> = ({ reviews, final, emptyState, focus }) => {
    const reviewsCount = reviews?.length || 0

    return (
        <Container>
        {reviewsCount !== 0 && reviews!.map((r, i) => (
            <>
                <ReviewItem review={r} key={r.id} focus={focus}/>
                { i !== reviewsCount - 1 && <Separator /> }
            </>
        ))}
        {final && reviewsCount === 0 && <div> {emptyState} </div>}
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    justify-items: start;
    align-items: center;

    grid-gap: 32px;

    width: 100%;
    height: 100%;
`


const Separator = styled.div`
    width: 100%;
    height: 1px;
    background: ${p => p.theme.colors.serviceGray};

    opacity: 0.6;
`


export default ReviewList